import { render, staticRenderFns } from "./HomeIntroduction.vue?vue&type=template&id=fd47c100&scoped=true"
import script from "./HomeIntroduction.vue?vue&type=script&lang=js"
export * from "./HomeIntroduction.vue?vue&type=script&lang=js"
import style0 from "./HomeIntroduction.vue?vue&type=style&index=0&id=fd47c100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd47c100",
  null
  
)

export default component.exports